import { Color } from '../../js/color';
import * as lodash from '../utils/lodash';
import { NAME_TRANSPARENT, RGBA_TRANSPARENT } from '../constant';
export { Color };
function brightenStringColor(color, ration) {
    var out = Color(color).lighten(ration);
    var alpha = out.alpha();
    if (alpha === 1) {
        return out.hex();
    }
    var red = Math.round(out.red());
    var green = Math.round(out.green());
    var blue = Math.round(out.blue());
    return "rgba(" + [red, green, blue, alpha].join(',') + ")";
}
export function brighten(color, ration) {
    if (ration === void 0) { ration = 0; }
    if (!color) {
        return color;
    }
    if (typeof color === 'string') {
        return brightenStringColor(color, ration);
    }
    if (color.isGradient) {
        var nextColor = color.clone();
        nextColor.option.stops.forEach(function (stop) {
            stop.color = brightenStringColor(stop.color, ration);
        });
        return nextColor;
    }
    return color;
}
export function alpha(color, alpha) {
    var out = Color(color).alpha(alpha);
    var red = Math.round(out.red());
    var green = Math.round(out.green());
    var blue = Math.round(out.blue());
    return "rgba(" + [red, green, blue, alpha].join(',') + ")";
}
export function isGradient(color) {
    return color && color.isGradient;
}
export function isPattern(color) {
    return color && color.isPattern;
}
export function isTransparent(color) {
    return color === RGBA_TRANSPARENT || color === NAME_TRANSPARENT;
}
export function getCtxColor(ctx, color, item) {
    if (lodash.isString(color)) {
        if (color === 'currentColor') {
            return getCtxColor(ctx, item.getExtendAttr('color'), item);
        }
        return color;
    }
    if (color.isGradient) {
        return color.getCanvasContextStyle(ctx, item.getBBox());
    }
    if (color.isPattern) {
        return color.getCanvasContextStyle(ctx, function () {
            item.dirty();
        });
    }
}
export function getSVGColor(color) {
    if (lodash.isString(color)) {
        return color;
    }
    if (isGradient(color) || isPattern(color)) {
        return "url(#" + color.id + ")";
    }
}
var MAX_SIZE = 32 * 32 * 32;
export function valueToRgb(index) {
    if (index >= MAX_SIZE) {
        console.warn('GPU pick element is larger than 32 * 32 * 32');
        return [0, 0, 0];
    }
    // eslint-disable-next-line no-bitwise
    var r = (index >> 10) % 32;
    // eslint-disable-next-line no-bitwise
    var g = (index >> 5) % 32;
    var b = index % 32;
    return [r * 8, g * 8, b * 8];
}
